import { useContext } from 'react';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
export function useWaysteClient(override) {
    const context = useContext(getWaysteContext());
    const client = override || context.client;
    invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <WaysteProvider>, or pass an WaysteClient ' +
        'instance in via options.');
    return client;
}
//# sourceMappingURL=useWaysteClient.js.map